import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import CircularProgress from '@material-ui/core/CircularProgress'
import Grid             from '@material-ui/core/Grid'
import IconButton       from '@material-ui/core/IconButton'
import TableCell        from '@material-ui/core/TableCell'
import TableRow         from '@material-ui/core/TableRow'
import DeleteIcon       from '@material-ui/icons/Delete'
import InfoIcon         from '@material-ui/icons/Info'

import { User }          from '../../api'
import { genFullName }   from '../../project-utils'
import { Communication } from '../../redux'
import { ClickPrompt }   from '../atoms'
import ProfileAvatar     from './ProfileAvatar'

interface UserListEntryProps {
  user: User,
  onInfoClick: () => void
  onDelete: () => void
  deleteCommunication: Communication
}

const UserListItem = ({
  onInfoClick,
  user,
  onDelete,
  deleteCommunication
}: UserListEntryProps) => {
  if (!user.account.active) {
    const deleteUserPrompt = <FormattedMessage id={'generic.deleteUserPrompt'} />

    const { fetching } = deleteCommunication

    return (
      <TableRow key={user.id}>
        <TableCell component="th" scope="row">
          {user.account.email}
        </TableCell>
        <TableCell style={{ width: 96 }} numeric>
          <ClickPrompt header={deleteUserPrompt}>
            <IconButton onClick={onDelete}>
              {fetching
                ? <CircularProgress size={20} color={'secondary'} />
                : <DeleteIcon color={'secondary'} />
              }
            </IconButton>
          </ClickPrompt>
        </TableCell>
      </TableRow>
    )
  }

  const avatar = <ProfileAvatar name={user.personal && user.personal.name} img={user.personal && user.personal.photo} />
  const fullName = genFullName({ firstName: user.personal && user.personal.name, surname: user.personal && user.personal.surname })

  return (
    <TableRow key={user.id}>
      <TableCell component="th" scope="row">
        <Grid container alignItems={'center'} spacing={16} wrap={'nowrap'}>
          <Grid item>
            {avatar}
          </Grid>
          <Grid item>
            {fullName}
          </Grid>
        </Grid>
      </TableCell>
      <TableCell numeric>
        <IconButton onClick={onInfoClick}>
          <InfoIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  )
}

export default UserListItem



// WEBPACK FOOTER //
// ./src/components/molecules/UserListItem.tsx